import { schema } from 'normalizr';

const memberSchema = new schema.Entity('members');

export default memberSchema;
